
    export const environment: any = {
  production: false,
  authUrl: 'https://dev-api.safeignite.com/api/v1/auth',
  deviceUrl: 'https://dev-api.safeignite.com/api/v1/device',
  vehicleUrl: 'https://dev-api.safeignite.com/api/v1/vehicle',
  homeUrl: 'https://dev-api.safeignite.com/api/v1/home',
  socketUrl: 'https://dev-api.safeignite.com',
  settingsUrl: 'https://dev-api.safeignite.com/api/v1/settings',
  usersUrl: 'https://dev-api.safeignite.com/api/v1/users',
  testUrl: 'https://dev-api.safeignite.com/api/v1',
  firebase: {"apiKey":"AIzaSyAnYhAziNRhgsy3g2pLUSZZkNvrtnlqLNA","authDomain":"otp-verification-75600.firebaseapp.com","projectId":"otp-verification-75600","storageBucket":"otp-verification-75600.appspot.com","messagingSenderId":"923821262163","appId":"1:923821262163:web:7453f5fb58b3a8f5384da6","vapidKey":"BGgakCi1rtHSr1qDsrqVnkPsxyS5veA78vXI6RpTQ5UYm9hGLZ6HVtwdd4YOVsFBCCDBQQVQosSBGe2JQlOTFNw"}

    };
